import { render } from "./PrintLabelView.vue?vue&type=template&id=163bf9d5&scoped=true"
const script = {}

import "./PrintLabelView.vue?vue&type=style&index=0&id=163bf9d5&scoped=true&lang=css"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163bf9d5"]])

export default __exports__